import "/polyfills/nodelist-foreach";
import events from "/events";

window.initialiseGoogleLogin = (node = document) => {
  const googleLogins = node.querySelectorAll(".js-google-signin");

  if (googleLogins.length <= 0) {
    return;
  }

  const googleClientID = document
    .querySelector("meta[name='google-signin-client_id']")
    .getAttribute("content");

  window.gapi.load("auth2", function(){
    const auth2 = window.gapi.auth2.init({
      // eslint-disable-next-line camelcase
      client_id: googleClientID,
      cookiepolicy: "single_host_origin"
    });

    googleLogins.forEach(el => {
      auth2.attachClickHandler(el, {}, function(googleUser) {
        const idToken = googleUser.getAuthResponse().id_token;

        window.gapi.auth2.getAuthInstance().signOut();
        const googleToken = document.querySelector(".js-google-id-token");

        googleToken.value = idToken;
        googleToken.parentNode.submit();
      });
    });
  });
};

if (window.googleApisLoaded) {
  window.initialiseGoogleLogin();
}

events.on("modal:auth-popup:step:login:opened", node => {
  if (window.googleApisLoaded) {
    window.initialiseGoogleLogin(node);
  }
});
